import { Form } from "react-bootstrap";
import { create } from "../../services/upload-files.service";
import { useState } from "react";
import useFetch from "../../hooks/useFetch";

const CreateUser = () => {

    const [formData, setFormData] = useState({})
    const [validationErrors, setValidationErrors] = useState({});
    const { data } = useFetch('role');
    // const navigate = useNavigate();

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        let data_name = '';
        if (e.target.selectedOptions && e.target.selectedOptions.length > 0) {
            data_name = e.target.selectedOptions[0].getAttribute('data-name') || '';
        }
        setFormData((preData) => ({ ...preData, [data_name ? data_name : name]: value }))
        setValidationErrors((prevErrors) => ({ ...prevErrors, [name]: '' }))
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        const errors = validateFormFields(formData);
        if (Object.keys(errors).length > 0) {
            setValidationErrors(errors);
        } else {
            try {
                const res = await create(formData, 'user');
                if (res && res.affectedRows > 0) {

                    setValidationErrors({ success: 'Successfully Registered' });
                    // setTimeout(() => {
                    //   const route = '/';
                    //   navigate(route, { state: { user: res } });
                    // }, 1000);
                } else {
                    setValidationErrors({ err: 'Please Enter a Valid Information' });
                }
            } catch (error) {
                setValidationErrors({ err: 'An Error Occurred. Please Try Again Later.' });
            }
            setFormData({});
        }
    };


    const validateFormFields = (formData) => {
        const errors = {};
        if (!formData.firstname || formData.firstname.trim() === "") {
            errors.firstname = "Please Enter First Name";
        }

        if (!formData.lastname || formData.lastname.trim() === "") {
            errors.lastname = "Please Enter Last Name";
        }

        if (!formData.email || formData.email.trim() === '') {
            errors.email = 'Please Enter an Email Address';
        } else if (!validateEmail(formData.email)) {
            errors.email = 'Please Enter a Valid Email Address';
        }

        if (!formData.contact || formData.contact.trim() === '') {
            errors.contact = 'Please Enter a Contact Number';
        } else if (!validateContactNumber(formData.contact)) {
            errors.contact = "Please Enter a Valid Contact Number";
        }

        if (!formData.password || formData.password.trim() === '') {
            errors.password = 'Please Enter a Password';
        }

        if (!Object.keys(formData).includes('user_role')) {
            errors.user_role = 'Please Select Role';
        }

        return errors;
    };


    const validateEmail = (email) => {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(email);
    };

    const validateContactNumber = (contactNumber) => {
        const contactNumberRegex = /^\d{10}$/;
        return contactNumberRegex.test(contactNumber);
    };

    return (
        <>
            <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                    <h1 className="h2">Create User</h1>
                </div>

                <div className='row'>
                    <div className='col-4'>
                        <div className='editprofile'>
                            <h4>User Details</h4>
                            <Form onSubmit={handleSubmit}>
                                <Form.Group className="mb-3" controlId="firstname">
                                    <Form.Label>First Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="firstname"
                                        value={formData.firstname ? formData.firstname : ""}
                                        onChange={handleInputChange}
                                    />
                                    {validationErrors.firstname && <div className="error login-error">{validationErrors.firstname}</div>}
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="lastname">
                                    <Form.Label>Last Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="lastname"
                                        value={formData.lastname ? formData.lastname : ""}
                                        onChange={handleInputChange}
                                    />
                                    {validationErrors.lastname && <div className="error login-error">{validationErrors.lastname}</div>}
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="username">
                                    <Form.Label>UserName</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="username"
                                        value={formData.username ? formData.username : ""}
                                        onChange={handleInputChange}
                                    />
                                    {validationErrors.username && <div className="error login-error">{validationErrors.username}</div>}
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="email">
                                    <Form.Label>Email</Form.Label>
                                    <Form.Control
                                        type="email"
                                        name="email"
                                        value={formData.email ? formData.email : ""}
                                        onChange={handleInputChange}
                                    />
                                    {validationErrors.email && <div className="error login-error">{validationErrors.email}</div>}
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="contact">
                                    <Form.Label>Contact</Form.Label>
                                    <Form.Control
                                        type="number"
                                        name="contact"
                                        value={formData.contact ? formData.contact : ""}
                                        onChange={handleInputChange}
                                    />
                                    {validationErrors.contact && <div className="error login-error">{validationErrors.contact}</div>}
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="password">
                                    <Form.Label>Password</Form.Label>
                                    <Form.Control
                                        type="password"
                                        name="password"
                                        value={formData.password ? formData.password : ""}
                                        onChange={handleInputChange}
                                    />
                                    {validationErrors.password && <div className="error login-error">{validationErrors.password}</div>}
                                </Form.Group>
                                <Form.Group className="mb-3" controlId="user_role">
                                    <Form.Label>Select User Role</Form.Label>
                                    <Form.Select defaultValue='' onChange={handleInputChange}>
                                        <option value="" disabled>Select Role</option>
                                        {data.data && data.data.length > 0 ? data.data.map((role, index) => {
                                            return (
                                                <option data-name="user_role" value={role.id} key={index}>{role.role_name}</option>
                                            )
                                        }) : ""}
                                    </Form.Select>
                                    {validationErrors.user_role && <div className="error login-error">{validationErrors.user_role}</div>}
                                    {/* <Form.Select defaultValue='viewer' onChange={handleInputChange}>
                                        <option data-name="user_role" value="1">viewer</option>
                                        <option data-name="user_role" value="2">contributor</option>
                                        <option data-name="user_role" value="3">administrator</option>
                                    </Form.Select>
                                    {validationErrors.user_role && <div className="error login-error">{validationErrors.user_role}</div>} */}
                                </Form.Group>
                                <button class="btn btn-primary btn-add mb-3" type="submit">  Save</button>
                            </Form>
                        </div>
                    </div>
                </div>
            </main>
        </>
    )

}

export default CreateUser;